<template>
  <div>
    <div class="app-card-header success-actions">
      <div class="heading-block">
        <h4 class="heading">{{ getChart.title }}</h4>
      </div>
    </div>
    <v-progress-circular
      v-if="(getChart.status.loading && getChart.series.length <= 0) || (getChart.status.loading && getChart.status.noData)"
      :indeterminate="true"
      :size="75"
      height="3"
      color="primary"
      class="progress-circular" />
    <v-progress-linear
      v-if="(getChart.status.loading && getChart.series.length > 0)"
      :indeterminate="true"
      height="3"
      color="primary"
      class="progress-card" />
    <div class="card-body px-0">
      <apexchart
        v-if="(!getChart.status.noData && !getChart.status.loading && getChart.series.length > 0) || (!getChart.status.noData && getChart.status.loading && getChart.series.length > 0)"
        ref="chart"
        type=donut
        height=350
        class="donut-fm"
        @click="pieSelect($event)"
        :options="getChart.chartOptions"
        :series="getChart.series" />
      <i-no-data v-if="getChart.status.noData && !getChart.status.loading" heading="Oops!" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'priceDistribution',
  props: {
    filters: {
      type: [String, Array, Object],
      default: null
    }
  },
  mounted () {
    this.requestChart()
  },
  computed: {
    getChart () {
      return this.$store.state.analyticsPriceDistributionModule.chart
    }
  },
  updated () {
    // alert('Price Distribution')
  },
  methods: {
    requestChart () {
      this.$store.dispatch('analyticsPriceDistributionModule/getChart', {
        sellers: this.filters.seller.model,
        categories: this.filters.category.model,
        brands: this.filters.brand.model,
        elemRef: this.$refs.chart
      })
    },
    pieSelect (e) {
      if (e.target.parentNode.nodeName === 'g' && e.target.parentNode.hasAttribute('data:realIndex')) {
        let index = e.target.parentNode.attributes.getNamedItem('data:realIndex').value
        let name = this.getChart.chartOptions.labels[index]
        this.$emit('downloadExcel', {name: name})
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/priceDistribution.vue